import React, { useCallback } from 'react';

import { Box, Button } from '@mui/material';

import useStyles from './styles';

const ALL = 'All';
const INTERVALS = Array.from({ length: 10 }, (_, index) => [index, index + 1].join('-'));
const OPTIONS = [{ label: ALL, value: null }, ...INTERVALS.map((interval) => ({ label: interval, value: interval }))];

interface Props {
    selected: string;
    onSelect: (interval: string | null) => void;
    getOptionHref: (month: string | null) => string;
    className?: string;
}

const CvssFilter: React.FC<Props> = ({ selected, onSelect, getOptionHref, className }) => {
    const { classes, cx } = useStyles();

    const handleSelect = useCallback(
        (event) => {
            event.preventDefault();
            const { option } = event.currentTarget.dataset;
            onSelect && onSelect(option || null);
        },
        [onSelect]
    );

    return (
        <Box className={cx(classes.container, className)}>
            {OPTIONS.map((option) => {
                const additional = getOptionHref
                    ? {
                          component: 'a',
                          href: getOptionHref(option.value)
                      }
                    : {};
                return (
                    <Button
                        key={option.label}
                        className={cx(classes.button, { [classes._selected]: option.value === (selected || null) })}
                        variant="outlined"
                        data-option={option.value}
                        onClick={handleSelect}
                        {...additional}
                    >
                        {option.label}
                    </Button>
                );
            })}
        </Box>
    );
};

export default CvssFilter;
